var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import m from "mithril";
import { MithrilTsxComponent } from "mithril-tsx-component";
import { cleanString, exec, increment } from "oj-utils";
import { updateIfChanged, animateClassNames, animateCreate, animateRemove, portal, immediate } from "oj-mithriljs-utils";
import { getTransitionDuration } from "oj-dom-utils";
import "./Dialog.scss";
var inc = increment();
var Dialog = (function (_super) {
    __extends(Dialog, _super);
    function Dialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = inc();
        _this.open = false;
        return _this;
    }
    Dialog.prototype.oninit = function (v) {
        this.open = v.attrs.open;
    };
    Dialog.prototype.onbeforeupdate = function (v, o) {
        var open = this.open;
        updateIfChanged("open", this, v, o);
        if (open !== this.open) {
            this.setFocus();
            exec(v.attrs.onopen, this.open);
        }
    };
    Dialog.prototype.view = function (v) {
        var _this = this;
        return m("div", { id: v.attrs.id, className: cleanString("Dialog", v.attrs.className, this.open && "active") }, this.open && [
            m("div", { className: cleanString("backdrop", v.attrs.animate && animateClassNames(v, "animate")), oncreate: function (e) { return v.attrs.animate ? animateCreate(e) : undefined; }, onbeforeremove: function (e) { return v.attrs.animate ? animateRemove(e) : undefined; }, onclick: v.attrs.dismiss ? function () {
                    _this.setOpen(v, false);
                    exec(v.attrs.ondismiss);
                } : undefined }),
            m("div", { className: cleanString("content", v.attrs.animate && animateClassNames(v, "animate")), onclick: function (e) {
                    e.stopPropagation();
                    exec(v.attrs.onclick, e);
                }, oncreate: function (e) {
                    var _a;
                    if (v.attrs.animate)
                        animateCreate(e);
                    (_a = e.dom.querySelector("input, textarea, button")) === null || _a === void 0 ? void 0 : _a.focus();
                }, onbeforeremove: function (e) { return v.attrs.animate ? animateRemove(e) : undefined; } }, v.children)
        ]);
    };
    Dialog.prototype.oncreate = function (v) {
        var _this = this;
        var _a;
        v.dom["setOpen"] = function (open) {
            if (open === void 0) { open = true; }
            _this.setOpen(v, open);
            m.redraw();
        };
        this.portal = portal(v.dom, (_a = v.attrs.portal) !== null && _a !== void 0 ? _a : document.body);
        window.on("keydown.Dialog.".concat(this.id), function (e) {
            if (!_this.open)
                return;
            if (e.key === "Escape") {
                _this.setOpen(v, false);
                m.redraw();
            }
        });
    };
    Dialog.prototype.onremove = function (v) {
        this.portal.reset();
        window.off("keydown.Dialog.".concat(this.id));
    };
    Dialog.prototype.setOpen = function (v, open) {
        if (this.open === open)
            return;
        this.open = open;
        this.setFocus();
        exec(v.attrs.onopen, this.open);
    };
    Dialog.prototype.setFocus = function () {
        if (this.open && !this.prevElement)
            this.prevElement = document.activeElement;
        else if (!this.open) {
            setTimeout(function (e) {
                e === null || e === void 0 ? void 0 : e.focus();
            }, getTransitionDuration(document.querySelector(".Dialog.active .backdrop")), this.prevElement);
            this.prevElement = undefined;
        }
    };
    return Dialog;
}(MithrilTsxComponent));
export { Dialog };
export var dialog = function (data) {
    var open = true;
    var imm = immediate({
        view: function (v) {
            return m(Dialog, __assign({}, data, { open: open, ondismiss: function () {
                    open = false;
                    exec(data.ondismiss);
                    imm.resolve(open);
                }, onopen: function (e) {
                    open = e;
                    exec(data.onopen, e);
                    imm.resolve(open);
                } }), data.content(function () { return open = false; }));
        }
    });
    exec(data.onopen, open);
    return imm.promise;
};
//# sourceMappingURL=Dialog.js.map